import React from 'react'

import EditPostContainer, { CommonContainerProps } from 'containers/EditPostContainer'
import GradientButton from 'components/Buttons/GradientButton'
import { Select } from 'components/EditPost/Position'
import LighterText from 'components/Text/Lighter'
import Popup from 'components/Popup'

import {
	Container,
	Calendar,
	Divider,
	PopUpContainer,
	Checkbox,
} from './Dates.style'
import ErrorText from 'components/Text/ErrorText'

interface SelectionType {
	startDate: Date
	endDate: Date
	approxStart: boolean
	approxEnd: boolean
	basis: Select
}

interface DatesProps extends CommonContainerProps<SelectionType> {
	initStartDate?: Date
	initEndDate?: Date
	initApproxStart?: boolean
	initApproxEnd?: boolean
	initBasis?: Select
}

export default class Dates extends React.Component<DatesProps> {
	state: {
		startDate: Date
		endDate: Date
		approxStart: boolean
		approxEnd: boolean
		basis: Select
	} = {
		startDate: this.props.initStartDate as Date,
		endDate: this.props.initEndDate as Date,
		approxStart: this.props.initApproxStart as boolean,
		approxEnd: this.props.initApproxEnd as boolean,
		basis: this.props.initBasis as Select,
	}

	setApproxStart(approxStart: boolean) {
		this.setState({ approxStart: approxStart })
	}

	setApproxEnd(approxEnd: boolean) {
		this.setState({ approxEnd: approxEnd })
	}

	setStartDate(date: any) {
		this.setState({ startDate: date })
	}

	setEndDate(date: any) {
		this.setState({ endDate: date })
	}

	wrongDate = () => {
		this.setStartDate(null)
		this.setEndDate(null)
	}

	render() {
		return (
			<EditPostContainer
				title='Dates'
				progressValue={50}
				{...this.props}
				onNext={() => {
					return this.props.onNext({
						startDate: this.state.startDate,
						endDate: this.state.endDate,
						approxStart: this.state.approxStart,
						approxEnd: this.state.approxEnd,
						basis: this.state.basis,
					})
				}}
				isNextAvailable={
					!!this.state.startDate
				}
			>
				<Container>
					<LighterText>Start Date</LighterText>
					{!this.state.startDate && <ErrorText>You must select a start date to continue</ErrorText>}

					<Calendar
						selectedDate={this.state.startDate || ((null as unknown) as Date)}
						onSelectedDate={date => this.setStartDate(date)}
					/>
					<Checkbox
						checked={this.state.approxStart}
						onSetChecked={approxStart => this.setApproxStart(approxStart)}
					>
						<p>Date is approximate</p>
					</Checkbox>
					{this.props.initBasis?.id !== 1 && (
						<>
							<Divider />
							<LighterText>End Date</LighterText>
							<Calendar
								selectedDate={this.state.endDate || ((null as unknown) as Date)}
								onSelectedDate={date => this.setEndDate(date)}
							/>
							<Checkbox
								checked={this.state.approxEnd}
								onSetChecked={approxEnd => this.setApproxEnd(approxEnd)}
							>
								<p>Date is approximate</p>
							</Checkbox>
						</>
					)}
				</Container>
				<Popup
					opened={!!this.state.startDate && !!this.state.endDate ? this.state.startDate > this.state.endDate : false}>
					<PopUpContainer>
						<h3>End date can’t be earlier than Start date.<br/> Please choose a different date.</h3>
						<GradientButton disabled={false} onClick={this.wrongDate} text="Ok" />
					</PopUpContainer>
				</Popup>
			</EditPostContainer>
		)
	}
}
